import React from 'react'

import MegaMenuItem from './MegaMenuItem'
import Submenu from './Submenu'

import { NormalLinkType } from '@contracts/wp/megaMenu'

import ArrowIcon from '@icons/arrow-right-controlled.svg'

import * as styles from './NormalLinks.module.scss'

type Props = {
	data: NormalLinkType[]
}

const NormalLinks: React.FC<Props> = ({ data }) => {
	const [isSubmenuOpen, setIsSubmenuOpen] = React.useState(false)

	const iconStyles = [styles.icon]

	if (isSubmenuOpen) {
		iconStyles.push(styles.isOpen)
	}

	return (
		<ul className={styles.normalLinks}>
			{data.map((normalLink, i) => {
				const itemStyles = [styles.normalLink]

				if (normalLink.submenu) {
					itemStyles.push(styles.hasSubmenu)
				}

				return (
					<li key={i} className={itemStyles.join(' ')}>
						<MegaMenuItem data={normalLink.megaMenuItem} className={styles.megaMenuItem} />

						{normalLink.submenu ? (
							<div className={styles.submenuWrapper}>
								<div className={styles.iconWrapper} onClick={() => setIsSubmenuOpen(!isSubmenuOpen)}>
									<ArrowIcon className={iconStyles.join(' ')} />
								</div>

								<Submenu data={normalLink.submenu} isOpen={isSubmenuOpen} className={styles.submenu} />
							</div>
						) : null}
					</li>
				)
			})}
		</ul>
	)
}

export default NormalLinks
